var _rect, _path, _path2, _path3, _path4, _g, _rect2, _rect3, _rect4, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClassroom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5460_5760)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 30,
    height: 30,
    rx: 3.75,
    fill: "#E5EEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.75C5 6.67893 6.67893 5 8.75 5H31.25C33.3211 5 35 6.67893 35 8.75V16.25H5V8.75Z",
    fill: "#3178FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0437 17.4965C36.9775 17.6275 36.8177 17.68 36.6867 17.6137L32.5374 15.5152C32.4065 15.449 32.354 15.2892 32.4202 15.1582L33.2297 13.5578C33.627 12.7721 34.5861 12.4573 35.3718 12.8546L37.15 13.754C37.9357 14.1514 38.2505 15.1104 37.8532 15.8961L37.0437 17.4965Z",
    fill: "#E87A95"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.487 37.4867C24.1844 37.6934 23.7728 37.4852 23.76 37.119L23.6046 32.6685C23.5923 32.315 23.9635 32.0777 24.2791 32.2374L28.1113 34.1755C28.4269 34.3351 28.4558 34.7747 28.1637 34.9743L24.487 37.4867Z",
    fill: "#ECC8A8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5460_5760",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 32,
    width: 6,
    height: 6
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.487 37.4867C24.1844 37.6934 23.7728 37.4852 23.76 37.119L23.6046 32.6685C23.5923 32.315 23.9635 32.0777 24.2791 32.2374L28.1113 34.1755C28.4269 34.3351 28.4558 34.7747 28.1637 34.9743L24.487 37.4867Z",
    fill: "#545760"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5460_5760)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.6875,
    y: 38.7739,
    width: 4.18479,
    height: 1.79348,
    transform: "rotate(-153.172 25.6875 38.7739)",
    fill: "#545760"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4102,
    y: 34.5684,
    width: 5.18116,
    height: 16.0749,
    transform: "rotate(-153.172 28.4102 34.5684)",
    fill: "#FFAA00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.6914,
    y: 20.7583,
    width: 5.64614,
    height: 3.85266,
    rx: 0.265701,
    transform: "rotate(-153.172 35.6914 20.7583)",
    fill: "#B5BBCB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36.2598,
    y: 20.0774,
    width: 6.04469,
    height: 0.531401,
    rx: 0.265701,
    transform: "rotate(-153.172 36.2598 20.0774)",
    fill: "#C3CBDA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 36.918,
    y: 18.7734,
    width: 6.04469,
    height: 0.531401,
    rx: 0.265701,
    transform: "rotate(-153.172 36.918 18.7734)",
    fill: "#C3CBDA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5460_5760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClassroom1);
export default __webpack_public_path__ + "static/media/icon-classroom1.27942799937778474e1c4af4321b8104.svg";
export { ForwardRef as ReactComponent };